<template>
  <footer class="footer">
    <div>
      <p class="li"><router-link :to="{name: 'PrivacyPolicy'}">プライバシーポリシー</router-link></p>
      <p><router-link :to="{name: 'Terms'}">利用規約</router-link></p>
      <p><router-link :to="{ name: 'Contact'}">お問い合わせ</router-link></p>
    </div>
    <p>Copyright © 2020 flew Inc. All rights reserved.</p>
  </footer>
</template>

<script>

  export default {
    name: "Footer",
  }
</script>

<style lang="scss" scoped>
  .footer {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    div {
      padding-top: 1rem;
      display: flex;
      justify-content: space-between;
      width: 30%;
    }

    @media screen and (max-width: 767px) {
      div {
        display: flex;
        justify-content: space-around;
        width: 100%;
      }
    }
  }
</style>
